ACC.formQuoteMobile = {
    _autoload: [
        "init",
        "bindFormQuoteMobile",
        "bindFormRfqMobile",
        "triggerChangeSelectRfq"
    ],
    init: function () {
        $(function () {
            $('input[name="deliveryAddress"]').val($('select#deliveryAddress option:selected').val());
            $('input[name="deliveryMode"]').val($('select#deliveryMode option:selected').val());
            ACC.formQuoteMobile.handleDeliveryModeList();
        });
    },
    bindFormQuoteMobile: function () {
        $('.js-save-simple').one('click', function () {
            $(this).addClass("disabled");
        });
        $('.close-btn-alert').on('click', function () {
            $(this).siblings(".error-msg").addClass("hidden");
        });

        $(document).on("submit", '#quoteMobile', function () {
            let $form = $('#quoteMobile .formPopup');
            let $reference = $('.js-reference-offer').val();
            if ($reference != "") {
                $(".without-ref").addClass("hidden");
                $(".with-ref").removeClass("hidden");
                $(".with-ref span").text(" " + $reference);
            } else {
                $(".with-ref").addClass("hidden");
                $(".without-ref").removeClass("hidden");
            }
            $.ajax({
                url: $form.attr("action"),
                data: $form.serialize(),
                type: $form.attr("method") ? $form.attr("method").toUpperCase() : "GET",
                success: function () {
                    $("#quoteMobile").addClass("hidden");
                    $("#successQuoteMobile").removeClass("hidden");
                    $("#successQuoteMobile .js-btn-redirect").on("click", function () {
                        let url = ACC.config.encodedContextPath + "/my-account/my-quotes"
                        window.location.replace(url);
                    });
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    $(".error-msg").text("error 2");
                    $('.js-save-simple').removeClass("disabled");
                }
            });
            return false;
        });
    },

    bindFormRfqMobile: function () {
        $('.js-save-simple').one('click', function () {
            $(this).addClass("disabled");
        });

        $('.close-btn-alert').on('click', function () {
            $(this).siblings(".error-msg").addClass("hidden");
        });

        let maxValInit = $(".commentRfq").attr("maxlength");
        $('#charNumRfq span').text(maxValInit);
        $(".commentRfq").on("input", function () {
            let maxVal = $(this).attr("maxlength");
            let len = $(this).val().length;

            if (len > maxVal) {
                $(this).val($(this).val().slice(0, maxVal));
            }

            $('#charNumRfq span').text(Math.max(0, maxVal - len));
        });

        function isValidDate(input) {
            let localeRegex = {
                    de: /^([0-2][0-9]|(3)[0-1])\.(0[1-9]|1[0-2])\.\d{4}$/,
                    nl: /^([0-2][0-9]|(3)[0-1])\-(0[1-9]|1[0-2])\-\d{4}$/,
                    en: /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/
                },
                currentLocale = $(".lang-current").text(),
                regex = localeRegex[currentLocale] || localeRegex.en;
            return regex.test(input);
        }

        $(document).on("submit", '.pageMobile .devisForm', function (e) {
            e.preventDefault();
            let givenValue = $(".confirmDevis #desiredDeliveryDate").val();
            if (givenValue != "" && !isValidDate(givenValue)) {
                $(".confirmDevis #desiredDeliveryDate").val("");
                $(".confirmDevis #desiredDeliveryDate").closest(".datedelivery").addClass("invalid");
            } else {
                $(".confirmDevis #desiredDeliveryDate").closest(".datedelivery").removeClass("invalid");
                let $form = $('.confirmDevis .devisForm');
                let $referenceRfq = $('.js-reference-rfq').val();
                if ($referenceRfq != "") {
                    $(".without-ref-rfq").addClass("hidden");
                    $(".with-ref-rfq").removeClass("hidden");
                    $(".with-ref-rfq .ref-text").text(" " + $referenceRfq);
                } else {
                    $(".with-ref-rfq").addClass("hidden");
                    $(".without-ref-rfq").removeClass("hidden");
                }
                $(".error-msg").text("");
                $(".error-msg").addClass("hidden");
                $.ajax({
                    url: $form.attr("action"),
                    data: $form.serialize(),
                    type: $form.attr("method") ? $form.attr("method").toUpperCase() : "GET",
                    success: function () {
                        $(".confirmDevis.pageMobile").addClass("hidden");
                        $("#successRfqMobile").removeClass("hidden");
                        $("#successRfqMobile .js-btn-redirect").on("click", function () {
                            let url = ACC.config.encodedContextPath + "/my-account/my-quotes"
                            window.location.replace(url);
                        });
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        $('.js-save-simple').removeClass("disabled");
                        if (jqXHR.status && jqXHR.status == 400) {
                            $(".error-msg").text(jqXHR.responseText);
                        } else {
                            $(".error-msg").text("Something went wrong");
                        }
                        $(".error-msg").removeClass("hidden");
                    }
                });
                return false;
            }
        });
    },
    extracted: function (addressDeliveryListSelector, deliveryModeListSelector) {
        $('.js-save-simple').addClass("disabled");
        let notPreorder = $(".jsPreorder").text();
        let idCode = $(addressDeliveryListSelector).siblings("ul.select-options").find("li.selected").attr('rel');
        $.ajax({
            url: ACC.config.encodedContextPath + '/cart/deliveryMode' + (idCode != undefined ? '?addressPk=' + idCode : ''),
            data: $(addressDeliveryListSelector).serialize(),
            type: "GET",
            success: function (data) {
                let item = "", itemStyled = "", selectedValue = "";
                $.each(data, function (index, value) {
                    if (index === 0) {
                        selectedValue = value.name + " - " + value.description;
                        if (value.eligible == true && !value.hidePrice) {
                            if (value.deliveryCostTTC.value < 0.1) {
                                selectedValue += " - " + $('.basketFree').text();
                            } else {
                                selectedValue += " - " + value.deliveryCost.formattedValue;
                            }
                        }
                    }
                    if (notPreorder == "true") {

                        item += "<option value='" + value.code + "'>" + value.name + " - " + value.description;
                        if (value.eligible == true && !value.hidePrice) {
                            if (value.deliveryCostTTC.value < 0.1) {
                                item += " - " + $('.basketFree').text();
                            } else {
                                item += " - " + value.deliveryCost.formattedValue;
                            }
                        }
                        item += "</option>";
                        itemStyled += "<li rel='" + value.code + "'>" + value.name + " - " + value.description;
                        if (value.eligible == true && !value.hidePrice) {
                            if (value.deliveryCostTTC.value < 0.1) {
                                itemStyled += " - " + $('.basketFree').text();
                            } else {
                                itemStyled += " - " + value.deliveryCost.formattedValue;
                            }
                        }
                        itemStyled += "</li>";
                    } else {
                        item += "<option value='" + value.code + "'>" + value.name + " - " + value.description;
                        if (value.eligible == true && !value.hidePrice) {
                            if (value.deliveryCostTTC.value < 0.1) {
                                item += " - " + $('.basketFree').text();
                            } else {
                                item += " - " + value.deliveryCost.formattedValue;
                            }
                        }
                        item += "</option>";

                        itemStyled += "<li rel='" + value.code + "'>" + value.name + " - " + value.description;

                        if (value.eligible == true && !value.hidePrice) {
                            if (value.deliveryCostTTC.value < 0.1) {
                                itemStyled += " - " + $('.basketFree').text();
                            } else {
                                itemStyled += " - " + value.deliveryCost.formattedValue;
                            }
                        }
                        itemStyled += "</li>";
                    }
                });

                $(deliveryModeListSelector).html(item);
                $(deliveryModeListSelector).siblings("ul.select-options").html(itemStyled)
                    .siblings(".select-styled").text(selectedValue);

                ACC.formQuoteMobile.handleDeliveryAddressList();
                ACC.formQuoteMobile.handleDeliveryModeList();

                $('.js-save-simple').removeClass("disabled");

            }
        });
    },
    triggerChangeSelectRfq: function () {
        let deliveryModeListSelector = '.deliveryModeList',
            addressDeliveryListSelector = '.addressDeliveryList';
        $(addressDeliveryListSelector).on("change", function () {
            ACC.formQuoteMobile.extracted(addressDeliveryListSelector, deliveryModeListSelector);
        });
    },

    handleDeliveryAddressList: function () {
        $('input[name="deliveryAddress"]').val($('select#deliveryAddress option:selected').val());
        $('input[name="deliveryMode"]').val($('select#deliveryMode option:selected').val());
    },
    handleDeliveryModeList: function () {
        let $selectedLi = $('#delivery-select .select-options li'),
            _value = '';
        $selectedLi.on('click', function () {
            //reset style & values
            $('.deliveryModeList option').removeAttr('selected');
            $selectedLi.removeClass('selected');
            //set values + style !
            $('#delivery-select .select-styled').html($(this).addClass('selected').html());
            _value = $(this).attr('rel');
            //update select option to fix issues linked to the style !
            $('.deliveryModeList').find(`option[value="${_value}"]`).attr("selected", true);
            $('input[name="deliveryMode"]').val(_value);
        });
    }


}